function activeTestService (optimizely, activeTests, $location) {
    return {
        isTestActive
    };

    function isTestActive (testName) {
        return !!(isOptimizelyActive(testName) || isQueryParamActive(testName));
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////

    function isOptimizelyActive (testName) {
        const test = activeTests[testName];

        try {
            const experiment = optimizely.get('state').getExperimentStates({isActive: true})[test.experimentId];

            return experiment
                && !experiment.isInExperimentHoldback
                && experiment.variation
                && experiment.variation.id === test.variationId;
        } catch (error) {
            return false;
        }
    }

    function isQueryParamActive (testName) {
        return $location.search()[testName];
    }
}

activeTestService.$inject = [
    'optimizely',
    'activeTests',
    '$location'
];

export default activeTestService;
